<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
      <a-row :gutter="24">
        <a-col :xl="4" :lg="7" :md="8" :sm="24">
            <a-form-item label="基地"  class="margin-botton-0"  >
                <j-dict-select-tag placeholder="请选择部门"   :isChooseFirst="true"  @chooseFirst="handleGotoToday" v-model="queryParam.base"  @input="handleChangeBase"   dictCode="bus_inspection_base,base,id,status = '1'" />
            </a-form-item>
        </a-col>
        <a-col  :xl="10" :md="12" :sm="24"  style="max-width: 400px"  >
          <a-form-item label="查询时间范围">
            <a-range-picker format="YYYY-MM-DD" v-model="queryParam.dateScope" @change="getNewDate" style="margin-right: 2%" />
          </a-form-item>
        </a-col>
        <a-col :xl="10"  :md="12" :sm="24">
            <a-button type="primary" @click="searchQuery" icon="search" style="margin-left: 21px">查询</a-button>
            <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            <a-button type="primary" @click="exportToExcel" icon="export" style="margin-left: 8px">导出</a-button>
        </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-operator">
    </div>
    <div   class="out-div"  >
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :scroll="{x:true}"
        :dataSource="dataSource"
        :loading="loading"      
        id="myTable" 
        :pagination="false"
        @change="handleTableChange">
      </a-table>
    </div>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {filterMultiDictText} from '@/components/dict/JDictSelectUtil'
  import { postAction,getAction  } from '@/api/manage'
  import JDate from '@/components/jeecg/JDate.vue'
  import FileSaver from 'file-saver'
  import XLSX from 'xlsx'
  import moment from "moment"

  export default {
    name: "TableInspectionSummary",
    mixins:[JeecgListMixin],
    components: {
         JDate
    },
    data () {
      return {
        // 表头
        url: {
          list: "/busInspectionReport/countInspectionPlan",
        },
        dictOptions:{},
        columns:[],
        rolePlanTypeDict:{},
        headerData:""
      }
    },
    computed: {
      
    },
    created(){
      getAction("/sys/dict/getDictItems/role_plan_type").then((res)=>{
        if(res.success){
          this.rolePlanTypeDict=res.result
        }
      })
      this.searchReset()
    },
    methods: {
      getNewDate(dateStrings){
        let diffDay=moment(dateStrings[1]).diff(moment(dateStrings[0]),'day')
        if(diffDay>31){
          this.$set(this.queryParam,"dateScope","")
          this.$set(this.queryParam,"startDate","")
          this.$set(this.queryParam,"endDate","")
          this.$message.error("选择时间跨度不得超过31天")
          return
        }
        this.queryParam.startDate = moment(dateStrings[0]).format('YYYY-MM-DD')
        this.queryParam.endDate =  moment(dateStrings[1]).format('YYYY-MM-DD')
      },
      exportToExcel () {
        let et = XLSX.utils.table_to_book(document.querySelector('#myTable')); //此处传入table的DOM节点
        console.log(11,et);
        let etout = XLSX.write(et, {
          bookType: 'xlsx',
          bookSST: true,
          type: 'array'
        });
        try {
            FileSaver.saveAs(new Blob([etout], {
                type: 'application/octet-stream'
            }), this.queryParam.base+'.xlsx');   //trade-publish.xlsx 为导出的文件名
        } catch (e) {
            console.log(e, etout) ;
        }
        return etout;
      },
      handleGotoToday () {
          
      },
      handleChangeBase () {
          
      },
      searchReset () {
          this.queryParam = {base:"厦门基地"}
          this.loadData(1);
      },
      handleReflush(){
        this.loadData()
      },
      loadData(){
        let columnsFreeze=[
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            key:"roleName",
            title:'组织',
            align:"center",
            dataIndex: 'roleName',
            customRender:(text, record, index)=>{
              let rowSpan=0
              if (index!=0&&this.dataSource[index-1].roleName==record.roleName) {
                rowSpan=0
              }else{
                rowSpan=1
                for (let i = index; i < this.dataSource.length-1; i++) {
                 if((i!=this.dataSource.length)&&(this.dataSource[i].roleName==this.dataSource[i+1].roleName)){
                   rowSpan++;
                 }else{
                   break
                 }
                }
                
              }
              return {
                children:text?text:" ",
                attrs: {
                  rowSpan: rowSpan,
                },
              }
            }
          },
          {
            key:"userName",
            title:'巡查',
            align:"center",
            dataIndex: 'userName'
          },
          {
            key:"planType",
            title:'周期',
            align:"center",
            dataIndex: 'planType',
            customRender:(text, record, index)=>{
              let dataText="";
              let rowSpan=0
              for (let i = 0; i < this.rolePlanTypeDict.length; i++) {
                if(text == this.rolePlanTypeDict[i].value){
                  dataText=this.rolePlanTypeDict[i].text
                };
              }
              if (index!=0&&this.dataSource[index-1].roleName==record.roleName) {
                rowSpan=0
              }else{
                rowSpan=1
                for (let i = index; i < this.dataSource.length-1; i++) {
                 if((i!=this.dataSource.length)&&(this.dataSource[i].roleName==this.dataSource[i+1].roleName)){
                   rowSpan++;
                 }else{
                   break
                 }
                }
                
              }
              return {
                children:dataText,
                attrs: {
                  rowSpan: rowSpan,
                },
              }
            }
          },
          {
            key:"planNum",
            title:'次数',
            align:"center",
            dataIndex: 'planNum'
          },
          {
            key:"questionRate",
            title:'巡查计划次数',
            align:"center",
            dataIndex: 'totalPlanNum',
          },
          {
            key:"improveRate",
            title:'实际巡查次数',
            align:"center",
            dataIndex: 'actualNum',
          },
          {
            key:"actualLeaveBusinessNum",
            title:'请假出差次数',
            align:"center",
            dataIndex: 'actualLeaveBusinessNum',
          },
          {
            key:"startDate",
            title:'巡查次数达成率',
            align:"center",
            dataIndex: 'actualRate',
            customRender(text){
              return text+"%"
            }
          },
        ]
        postAction("/inspection/api/report/getBaseDepartWorkshop",).then((res)=>{
            if(res.code==200){
              this.columns=[{
                children:columnsFreeze,
                title:"timeScoped",
                align:"center",
                dataIndex: "timeScoped",
                key:"timeScoped"
              }];
              let workshopData=[]
              let resTmep=[]
              res.result.forEach(element => {
                if(element.text==this.queryParam.base){
                  resTmep=element.children
                }
              });
              resTmep.forEach((element,index) => {
                workshopData.push({
                    title:element.text,
                    children:[],
                    align:"center",
                })
                element.children.forEach((item,i)=>{
                  workshopData[index].children.push({
                    title:item.text,
                    align:"center",
                    dataIndex: element.text+item.text,
                    key:element.value+item.value
                  })
                })
              });
              this.columns[0].children.splice(5,0,...workshopData);
              this.dataSource=res.result.planList
              if (!this.url.list) {
                  this.$message.error("请设置url.list属性!")
                  return
              }
              var params = this.getQueryParams();//查询条件
              this.loading = true;
              postAction(this.url.list, params).then((res) => {
                  if (res.success) {
                      this.dataSource = res.result.planList;
                      this.columns[0].title=`${res.result.weekNum}（时间：${res.result.startDate}到${res.result.endDate}）`
                  }else{
                    this.$message.error(res.message)
                  }
                  this.loading = false;
              })
            }else{
              this.$message.error(res.message)
            }
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
  .time-pick{
    min-width: 480px;
    display: inline;
  }
  .out-div{
    // width: 100%;
    // overflow: scroll;
  }
</style>